import { FormikProps } from "formik";
import { useEffect, useMemo, useState } from "react";

import { useSavedViewStore } from "../..";
import ISavedView, { SavedViewDraft } from "../../interfaces/ISavedView";
import InputContainer from "./InputContainer";
import InputWithSearch from "./InputWithSearchFormikEntitySelect";

export default function SavedViewSelectInput({ formik, label, placeholder = "Search views...", limit = 20 }: SavedViewSelectInputProps) {
    const savedViewStore = useSavedViewStore();
    const [value, setValue] = useState<string>((formik.values.name as string) || "");
    const [query, setQuery] = useState<string>((formik.values.name as string) || "");

    const searchResult = useMemo(() => {
        const q = query.trim().toLowerCase();
        const items = q ? savedViewStore.savedViews.filter(sv => sv.name.toLowerCase().includes(q)) : savedViewStore.savedViews;

        return {
            query,
            items: items.slice(0, limit),
        };
    }, [query, savedViewStore.savedViews, limit]);

    useEffect(() => {
        const next = (formik.values.name as string) || "";
        setValue(next);
        setQuery(next);
    }, [formik.values.name]);

    return (
        <InputContainer name="name" label={label} formik={formik}>
            <InputWithSearch<ISavedView>
                value={value}
                placeholder={placeholder}
                debouncedOnChange={setQuery}
                searchResult={searchResult}
                getKey={sv => sv.id}
                getItemText={sv => sv.name}
                onValueChange={setValue}
                onSelect={sv => {
                    setValue(sv.name);
                    setQuery(sv.name);

                    formik.setValues({
                        id: sv.id,
                        name: sv.name,
                        isShared: sv.isShared,

                        includeFocusArea: Boolean(sv.viewState.focusArea),
                        includeAllFilterSettings: Boolean(sv.viewState.filters),
                        includeVisibleLayerSettings: Boolean(sv.viewState.visibleLayers),
                        includeBaseMapSettings: Boolean(sv.viewState.baseMap),
                        includeCompanyIdsToViewOnMap: Boolean(sv.viewState.companyIdsToViewOnMap),
                    });
                }}
            />
        </InputContainer>
    );
}

type SavedViewSelectInputProps = {
    formik: FormikProps<SavedViewDraft>;
    label: string;
    placeholder?: string;
    limit?: number;
};
